import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackForgotPasswordView = (): void => {
  trackingService.trackEvent(
    'FORGOT_PASSWORD',
    PRODUCT_NAME,
    {
      page: 'esqueceu senha',
      route: '/esqueceu-senha',
      placement: '',
      surface: '',
      flow: 'login',
      step: 'esqueceu senha',
      element: '',
      action: 'view',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackForgotPasswordSubmit = (): void => {
  trackingService.trackEvent(
    'FORGOT_PASSWORD',
    PRODUCT_NAME,
    {
      page: 'esqueceu senha',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'esqueceu senha',
      step: 'recuperação',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
